export function SucceedHandle(code = 0, msg = "", callBack = null) {
  let result = "";
  switch (code) {
    case 0:
      result = "";
      callBack && callBack();
      break;
    case 3: // 会话超时
      result = "当前用户尚未登录";
      break;
    case 8002: // token不存在
      result = "接口出错，代码：8002，TOKEN不存在";
      break;
    case 9999: // 请重试
      result = "接口出错，代码：9999，请重试";
      break;
    default:
      result = msg;
      break;
  }
  return result;
}

export function SucceedHandle2(code = 0, msg = "", ok_func = null, no_func = null) {
  if (code === 0) {
    ok_func && ok_func();
  } else {
    let result_msg = "";
    if (code === 3) // 会话超时
      result_msg = "当前用户尚未登录";
    else if (code === 8002) // token不存在
      result_msg = "接口出错，代码：8002，TOKEN不存在";
    else if (code === 9999) // 请重试
      result_msg = "接口出错，代码：9999，请重试";
    else
      result_msg = msg;
    no_func && no_func(code, result_msg);
  }
}

export function SucceedHandle3(code = 0, innerCode = 0, msg = "", ok_func = null, no_func = null) {
  if (code === 0) {
    ok_func && ok_func();
  } else {
    let result_msg = "";
    if (code === 3) // 会话超时
      result_msg = "当前用户尚未登录";
    else if (code === 8002) // token不存在
      result_msg = "接口出错，代码：8002，TOKEN不存在";
    else if (code === 9999) // 请重试
      result_msg = "接口出错，代码：9999，请重试";
    else
      result_msg = msg;
    no_func && no_func(code, innerCode, result_msg);
  }
}

export function NotSucceedHandle(errMsg = "") {
  let result = "";
  switch (errMsg) {
    case "timeout of 10000ms exceeded":
      result = "会话超时，请退出当前APP并重新登录";
      break;
    case "No message available":
      result = "会话无响应，请退出当前APP并重新登录";
      break;
    default:
      result = "";
      break;
  }
  return result;
}